export function UnityLogo() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 888 930"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33509 1.53309C0.93509 2.33309 0.801757 156.333 1.06842 343.933L1.33509 685L4.80176 697.666C8.66842 711.8 12.2684 722.866 14.9351 729.266C15.8684 731.533 16.6684 734.066 16.6684 734.866C16.6684 736.466 24.4018 753.533 29.6018 763.666C35.7351 775.4 46.9351 792.866 52.2684 799C55.0684 802.333 59.0684 807.266 61.0684 809.933C71.8684 824.466 106.402 854.733 123.868 864.866C127.468 867 132.268 869.933 134.668 871.666C139.335 874.733 151.468 880.866 169.335 889C175.202 891.666 181.868 894.733 184.002 895.666C186.268 896.733 191.602 898.466 196.002 899.533C200.402 900.6 208.802 903.266 214.668 905.533C224.268 909.133 232.802 911.266 259.335 916.866C281.602 921.666 280.135 921.4 326.002 926.466C351.602 929.266 406.535 930.333 441.335 928.466C478.402 926.6 520.402 923.4 532.002 921.666C537.202 920.866 546.135 919.666 552.002 919C557.868 918.333 565.335 917.133 568.668 916.333C572.002 915.666 585.202 913 598.002 910.333C625.468 904.866 651.068 898.466 668.668 892.466C675.602 890.066 683.202 887.666 685.335 887C691.202 885.4 705.602 879.933 714.668 875.8C719.068 873.8 724.535 871.4 726.668 870.466C756.535 857 789.202 835.933 813.068 814.6C830.802 798.733 848.668 775.4 857.868 756.066C863.068 745.133 871.868 718.066 873.202 709.266L874.135 703H758.268H642.535L635.602 716.866C623.468 741.266 599.468 767.266 575.868 781.8C551.468 796.733 530.935 804.333 500.668 809.933C478.935 813.933 424.935 814.866 400.002 811.666C371.602 807.933 368.402 807.533 358.802 805.133C350.535 803.133 344.268 801.133 324.002 794.066C317.602 791.933 294.935 779.533 289.202 775.133C275.602 764.6 268.268 758.066 263.335 751.666C260.002 747.4 255.335 741.666 252.935 738.733C246.002 730.2 234.668 705.133 229.468 687C219.735 652.2 220.135 666.6 219.735 383C219.468 221.666 219.868 128.333 220.668 127C221.735 125.266 260.802 124.866 554.268 124.333L886.668 123.666L886.802 63.6664C886.935 30.5998 886.668 2.86642 886.268 1.93309C885.868 0.73309 796.135 0.33309 444.002 0.33309C169.068 0.33309 1.86842 0.866423 1.33509 1.53309Z"
        fill="#324797"
      />
      <path
        d="M664.667 227C666.4 228.2 666.4 228.6 664.4 230.2C662.133 231.8 662 243.666 662 444.2V656.333H772.8C868 656.333 883.733 656.066 885.467 654.333C887.2 652.733 887.333 624.466 887.067 439.4L886.667 226.333L774.667 226.066C699.2 225.8 663.333 226.2 664.667 227Z"
        fill="#324797"
      />
      <path
        d="M259.336 409.666V460.333H382.669H506.003V409.666V359H382.669H259.336V409.666Z"
        fill="#324797"
      />
    </svg>
  );
}

export function UnityLogoWhite() {
  return (
    <svg
      width="90"
      height="90"
      viewBox="0 0 888 930"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33509 1.53309C0.93509 2.33309 0.801757 156.333 1.06842 343.933L1.33509 685L4.80176 697.666C8.66842 711.8 12.2684 722.866 14.9351 729.266C15.8684 731.533 16.6684 734.066 16.6684 734.866C16.6684 736.466 24.4018 753.533 29.6018 763.666C35.7351 775.4 46.9351 792.866 52.2684 799C55.0684 802.333 59.0684 807.266 61.0684 809.933C71.8684 824.466 106.402 854.733 123.868 864.866C127.468 867 132.268 869.933 134.668 871.666C139.335 874.733 151.468 880.866 169.335 889C175.202 891.666 181.868 894.733 184.002 895.666C186.268 896.733 191.602 898.466 196.002 899.533C200.402 900.6 208.802 903.266 214.668 905.533C224.268 909.133 232.802 911.266 259.335 916.866C281.602 921.666 280.135 921.4 326.002 926.466C351.602 929.266 406.535 930.333 441.335 928.466C478.402 926.6 520.402 923.4 532.002 921.666C537.202 920.866 546.135 919.666 552.002 919C557.868 918.333 565.335 917.133 568.668 916.333C572.002 915.666 585.202 913 598.002 910.333C625.468 904.866 651.068 898.466 668.668 892.466C675.602 890.066 683.202 887.666 685.335 887C691.202 885.4 705.602 879.933 714.668 875.8C719.068 873.8 724.535 871.4 726.668 870.466C756.535 857 789.202 835.933 813.068 814.6C830.802 798.733 848.668 775.4 857.868 756.066C863.068 745.133 871.868 718.066 873.202 709.266L874.135 703H758.268H642.535L635.602 716.866C623.468 741.266 599.468 767.266 575.868 781.8C551.468 796.733 530.935 804.333 500.668 809.933C478.935 813.933 424.935 814.866 400.002 811.666C371.602 807.933 368.402 807.533 358.802 805.133C350.535 803.133 344.268 801.133 324.002 794.066C317.602 791.933 294.935 779.533 289.202 775.133C275.602 764.6 268.268 758.066 263.335 751.666C260.002 747.4 255.335 741.666 252.935 738.733C246.002 730.2 234.668 705.133 229.468 687C219.735 652.2 220.135 666.6 219.735 383C219.468 221.666 219.868 128.333 220.668 127C221.735 125.266 260.802 124.866 554.268 124.333L886.668 123.666L886.802 63.6664C886.935 30.5998 886.668 2.86642 886.268 1.93309C885.868 0.73309 796.135 0.33309 444.002 0.33309C169.068 0.33309 1.86842 0.866423 1.33509 1.53309Z"
        fill="white"
      />
      <path
        d="M664.667 227C666.4 228.2 666.4 228.6 664.4 230.2C662.133 231.8 662 243.666 662 444.2V656.333H772.8C868 656.333 883.733 656.066 885.467 654.333C887.2 652.733 887.333 624.466 887.067 439.4L886.667 226.333L774.667 226.066C699.2 225.8 663.333 226.2 664.667 227Z"
        fill="white"
      />
      <path
        d="M259.336 409.666V460.333H382.669H506.003V409.666V359H382.669H259.336V409.666Z"
        fill="white"
      />
    </svg>
  );
}

export function TopArrow() {
  return (
    <svg
      id="Layer_1"
      enable-background="new 0 0 50 50"
      height="300"
      viewBox="0 0 50 50"
      width="300"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlnsSvgjs="http://svgjs.dev/svgjs"
    >
      <g width="100%" height="100%" transform="matrix(1,0,0,1,0,0)">
        <circle
          cx="25"
          cy="25"
          fill="#ffffff"
          r="25"
          fill-opacity="1"
          data-original-color="#dba627ff"
          stroke="none"
          stroke-opacity="1"
        />
        <path
          d="m40.355 30.617-15.355-13.488-15.355 13.488 1.98 2.254 13.375-11.749 13.375 11.749z"
          fill="#314898"
          fill-opacity="1"
          data-original-color="#ffffffff"
          stroke="none"
          stroke-opacity="1"
        />
      </g>
    </svg>
  );
}

export function Telephone() {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
      width="20"
      height="20"
      xmlnsSvgjs="http://svgjs.dev/svgjs"
    >
      <g width="100%" height="100%" transform="matrix(1,0,0,1,0,0)">
        <g>
          <g>
            <path
              d="M436.992,74.953c-99.989-99.959-262.08-99.935-362.039,0.055s-99.935,262.08,0.055,362.039s262.08,99.935,362.039-0.055&#10;&#9;&#9;&#9;c48.006-48.021,74.968-113.146,74.953-181.047C511.986,188.055,485.005,122.951,436.992,74.953z M387.703,356.605&#10;&#9;&#9;&#9;c-0.011,0.011-0.022,0.023-0.034,0.034v-0.085l-12.971,12.885c-16.775,16.987-41.206,23.976-64.427,18.432&#10;&#9;&#9;&#9;c-23.395-6.262-45.635-16.23-65.877-29.525c-18.806-12.019-36.234-26.069-51.968-41.899&#10;&#9;&#9;&#9;c-14.477-14.371-27.483-30.151-38.827-47.104c-12.408-18.242-22.229-38.114-29.184-59.051&#10;&#9;&#9;&#9;c-7.973-24.596-1.366-51.585,17.067-69.717l15.189-15.189c4.223-4.242,11.085-4.257,15.326-0.034&#10;&#9;&#9;&#9;c0.011,0.011,0.023,0.022,0.034,0.034l47.957,47.957c4.242,4.223,4.257,11.085,0.034,15.326c-0.011,0.011-0.022,0.022-0.034,0.034&#10;&#9;&#9;&#9;l-28.16,28.16c-8.08,7.992-9.096,20.692-2.389,29.867c10.185,13.978,21.456,27.131,33.707,39.339&#10;&#9;&#9;&#9;c13.659,13.718,28.508,26.197,44.373,37.291c9.167,6.394,21.595,5.316,29.525-2.56l27.221-27.648&#10;&#9;&#9;&#9;c4.223-4.242,11.085-4.257,15.326-0.034c0.011,0.011,0.022,0.022,0.034,0.034l48.043,48.128&#10;&#9;&#9;&#9;C391.911,345.502,391.926,352.363,387.703,356.605z"
              fill="#ffffff"
              fill-opacity="1"
              data-original-color="#000000ff"
              stroke="none"
              stroke-opacity="1"
            />
          </g>
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </g>
    </svg>
  );
}

export function FaxIcon() {
  return (
    <svg
      clip-rule="evenodd"
      fill-rule="evenodd"
      height="20"
      image-rendering="optimizeQuality"
      shape-rendering="geometricPrecision"
      text-rendering="geometricPrecision"
      viewBox="0 0 800 800"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      xmlnsSvgjs="http://svgjs.dev/svgjs"
    >
      <g width="100%" height="100%" transform="matrix(1,0,0,1,0,0)">
        <linearGradient
          id="id0"
          gradientUnits="userSpaceOnUse"
          x1="-.001"
          x2="800.001"
          y1="400"
          y2="400"
        >
          <stop stop-opacity="1" stop-color="#ffffff" offset="0" />
          <stop stop-opacity="1" stop-color="#ffffff" offset="0.98" />
        </linearGradient>
        <g id="Layer_x0020_1">
          <circle
            cx="400"
            cy="400"
            fill="url(#id0)"
            r="400"
            data-original-color="id0"
            stroke="none"
            strokeOpacity="1"
          />
          <g fill="#fff">
            <path
              d="m145 593v-207h510v207zm391-150h-272c-4 0-6-3-6-6 0-4 2-6 6-6h272c4 0 6 2 6 6 0 3-2 6-6 6zm39 35h-350c-4 0-6-3-6-6s2-6 6-6h350c4 0 6 3 6 6s-2 6-6 6zm0 35h-350c-4 0-6-3-6-6s2-6 6-6h350c4 0 6 3 6 6s-2 6-6 6zm0 35h-350c-4 0-6-2-6-6 0-3 2-6 6-6h350c4 0 6 3 6 6 0 4-2 6-6 6z"
              fill="#1f2937"
              fill-opacity="1"
              data-original-color="#ffffffff"
              stroke="none"
              strokeOpacity="1"
            />
            <path
              d="m145 374v-22c0-16 13-29 29-29h452c16 0 29 13 29 29v22zm481 282h-452c-16 0-29-13-29-29v-22h510v22c0 16-13 29-29 29z"
              fill="#1f2937"
              fill-opacity="1"
              data-original-color="#ffffffff"
              stroke="none"
              stroke-opacity="1"
            />
            <path
              d="m579 335h-358c-4 0-6-3-6-6v-23c0-16 13-28 28-28h314c15 0 28 12 28 28v23c0 3-2 6-6 6z"
              fill="#1f2937"
              fill-opacity="1"
              data-original-color="#ffffffff"
              stroke="none"
              stroke-opacity="1"
            />
            <path
              d="m539 290h-278c-3 0-6-3-6-6v-134c0-3 3-6 6-6h278c3 0 6 3 6 6v134c0 3-3 6-6 6zm-272-12h266v-122h-266z"
              fill="#1f2937"
              fill-opacity="1"
              data-original-color="#ffffffff"
              stroke="none"
              stroke-opacity="1"
            />
            <path
              d="m304 186h-16c-3 0-6-3-6-6 0-4 3-6 6-6h16c3 0 6 2 6 6 0 3-3 6-6 6z"
              fill="#1f2937"
              fill-opacity="1"
              data-original-color="#ffffffff"
              stroke="none"
              stroke-opacity="1"
            />
            <path
              d="m345 186h-15c-4 0-6-3-6-6 0-4 2-6 6-6h15c4 0 6 2 6 6 0 3-2 6-6 6z"
              fill="#1f2937"
              fill-opacity="1"
              data-original-color="#ffffffff"
              stroke="none"
              stroke-opacity="1"
            />
            <path
              d="m387 186h-16c-3 0-6-3-6-6 0-4 3-6 6-6h16c3 0 6 2 6 6 0 3-3 6-6 6z"
              fill="#1f2937"
              fill-opacity="1"
              data-original-color="#ffffffff"
              stroke="none"
              stroke-opacity="1"
            />
            <path
              d="m429 186h-16c-3 0-6-3-6-6 0-4 3-6 6-6h16c3 0 6 2 6 6 0 3-3 6-6 6z"
              fill="#1f2937"
              fill-opacity="1"
              data-original-color="#ffffffff"
              stroke="none"
              stroke-opacity="1"
            />
            <path
              d="m470 186h-15c-4 0-6-3-6-6 0-4 2-6 6-6h15c4 0 6 2 6 6 0 3-2 6-6 6z"
              fill="#1f2937"
              fill-opacity="1"
              data-original-color="#ffffffff"
              stroke="none"
              stroke-opacity="1"
            />
            <path
              d="m512 186h-16c-3 0-6-3-6-6 0-4 3-6 6-6h16c3 0 6 2 6 6 0 3-3 6-6 6z"
              fill="#1f2937"
              fill-opacity="1"
              data-original-color="#ffffffff"
              stroke="none"
              stroke-opacity="1"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function FacebookIcon() {
  return (
    <svg
      id="Layer_1"
      height="20"
      viewBox="0 0 512 512"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlnsSvgjs="http://svgjs.dev/svgjs"
    >
      <g width="100%" height="100%" transform="matrix(1,0,0,1,0,0)">
        <path
          d="m255.1824 7.7579q69.23.79 125.0851 34.0293a249.7343 249.7343 0 0 1 88.8909 89.4346q33.0371 56.1914 33.8244 125.8428-1.962 95.3-60.1167 162.791c-38.77 44.9941-88.425 72.83-139.8274 83.5009v-178.1275h48.5969l10.99-70h-73.5869v-45.8481a39.844 39.844 0 0 1 8.4739-26.3232q8.8275-11.2527 31.0895-11.8287h44.4366v-61.3184q-.9563-.3077-18.15-2.4336a360.7434 360.7434 0 0 0 -39.16-2.4336q-44.4328.205-70.2811 25.0674-25.8488 24.8554-26.4085 71.9209v53.1973h-56v70h56v178.1275c-63.1149-10.6709-112.77-38.5068-151.54-83.5009s-58.808-99.2578-60.1162-162.791q.7851-69.6546 33.8236-125.8428a249.7389 249.7389 0 0 1 88.8917-89.4346q55.8534-33.2329 125.0842-34.0293z"
          fill-rule="evenodd"
          fill="#ffffff"
          fill-opacity="1"
          data-original-color="#000000ff"
          stroke="none"
          stroke-opacity="1"
        />
      </g>
    </svg>
  );
}

export function LinkedInIcon() {
  return (
    <svg
      height="20"
      viewBox="0 0 512 512"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlnsSvgjs="http://svgjs.dev/svgjs"
    >
      <g width="100%" height="100%" transform="matrix(1,0,0,1,0,0)">
        <path
          d="m256 0c-141.363281 0-256 114.636719-256 256s114.636719 256 256 256 256-114.636719 256-256-114.636719-256-256-256zm-74.390625 387h-62.347656v-187.574219h62.347656zm-31.171875-213.1875h-.40625c-20.921875 0-34.453125-14.402344-34.453125-32.402344 0-18.40625 13.945313-32.410156 35.273437-32.410156 21.328126 0 34.453126 14.003906 34.859376 32.410156 0 18-13.53125 32.402344-35.273438 32.402344zm255.984375 213.1875h-62.339844v-100.347656c0-25.21875-9.027343-42.417969-31.585937-42.417969-17.222656 0-27.480469 11.601563-31.988282 22.800781-1.648437 4.007813-2.050781 9.609375-2.050781 15.214844v104.75h-62.34375s.816407-169.976562 0-187.574219h62.34375v26.558594c8.285157-12.78125 23.109375-30.960937 56.1875-30.960937 41.019531 0 71.777344 26.808593 71.777344 84.421874zm0 0"
          fill="#ffffff"
          fill-opacity="1"
          data-original-color="#000000ff"
          stroke="none"
          stroke-opacity="1"
        />
      </g>
    </svg>
  );
}
